import Head from 'next/head'
import Script from 'next/script'
import { Faq } from '../../components/commons/Faq';
import { serviceProviderFaq } from '../../utils/faq';

export default function Home(props) {
  
  return (
    <>
      <Head>
        <title>Service Provider FAQs StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Frequently asked questions by service providers"/>
        <meta name="keywords" content="Frequently asked questions by service providers"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/faq/service-provider" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="Service Provider FAQs StringsSG"/>
        <meta property="og:description" content="Frequently asked questions by service providers" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/faq/service-provider"/>
        <meta name="twitter:title" content="Service Provider FAQs StringsSG"/> 
        <meta name="twitter:description" content="Frequently asked questions by service providers"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/faq/service-provider" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [{
                  "@type": "Question",
                  "name": "How to sign up as a service provider?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Go to https://www.stringssg.com/service-provider-signup and fill up all required information. Make sure to select the relevant service category and entity type."
                  }
                },{
                  "@type": "Question",
                  "name": "How to stop receiving email and app notification when a new request is opened by client?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Navigate to Account > Preferences to manage email and app notification."
                  }
                },{
                  "@type": "Question",
                  "name": "Can I trust the requests opened by clients?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "New requests can only be opened manually by answering to the questionaires for the required service. Requester will need to go through an email and mobile verification system to verify their email and mobile number. Mobile and email verified requesters are tagged accordingly. If our system notices any anomalies in the request, the request will be auto canceled."
                  }
                },{
                  "@type": "Question",
                  "name": "Is the mobile number provided by the client valid?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, all mobile numbers go through a verification process before they can be added to a profile."
                  }
                },{
                  "@type": "Question",
                  "name": "After I have responded to the request, how do I interact further with the requester?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can use the in-built chat system to chat with the requester or you can also call or WhatsApp the requester if they have provided their mobile number."
                  }
                },{
                  "@type": "Question",
                  "name": "Why do not I get a response back from the client (for Financial Advisers, Gyms/Personal Trainers)",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "When responding to a request ensure that you are good match for the request and attached your offer (if any) which is relevant to the request. A request may be responded by multiple professionals in the area, so it is important to attend to new requests as soon as possible and use the Call/WhatsApp option to directly interact with the client."
                  }
                }]
              }
              `
          }}
        />
      </Head>
        <div className='max-w-5xl mx-auto'>  
            <Faq 
              questionsAnswers={serviceProviderFaq}
              title="FAQs for Service Providers"
            /> 
        </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}